module.exports = __webpack_public_path__ + "img/signed.aec7110d.png";